import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { Menus } from 'src/app/model/menu'
import { MenusJson} from '../../plainData/menu'
import 'firebase/firestore';
import { getLocaleDateFormat } from '@angular/common';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  menusCollection: AngularFirestoreCollection<Menus>;
  menu$: Observable<Menus[]>;
  public menusJson = MenusJson;

  constructor(public afs:AngularFirestore) {

    this.menusCollection = this.afs.collection<Menus>('menus');
    console.log(this.menusJson)
    
    
   }

  

  ngOnInit(): void {
  }

}
